import { render } from "./VODFolderCard.vue?vue&type=template&id=0b5892e5"
import script from "./VODFolderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VODFolderCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/VODFolderCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b5892e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b5892e5', __exports__)) {
    api.reload('0b5892e5', __exports__)
  }
  
  module.hot.accept("./VODFolderCard.vue?vue&type=template&id=0b5892e5", () => {
    api.rerender('0b5892e5', render)
  })

}


export default __exports__